// extracted by mini-css-extract-plugin
export default {"calendar":"Carlender_calendar__cL9Js","date":"Carlender_date__M7eLN"};